import Vue from "vue";
import App from "../views/App";

import router from "./router";
import store from "./store";

// Styles
import "../assets/sass/global.scss"; // Import global styles

import "inobounce"; // Disable elastic scrolling on iOS

// Remove click delay on touch devices
import FastClick from "fastclick";
if ("addEventListener" in document) {
  document.addEventListener(
    "DOMContentLoaded",
    function() {
      FastClick.attach(document.body);
    },
    false
  );
}

// Hack to fix webpack issue with Leaflet
// https://github.com/KoRiGaN/Vue2Leaflet/issues/96
import L from "leaflet";
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

// Vue Marker Cluster
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
Vue.component("v-marker-cluster", Vue2LeafletMarkerCluster);
import "../../node_modules/leaflet.markercluster/dist/MarkerCluster.css";
import "../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css";

// Firebase
import firebase from "firebase";
import "firebase/firestore";
import VueFire from "vuefire";
Vue.use(VueFire);

// Firebase
import { config } from "./firebaseConfig.js";
export var firebaseApp = firebase.initializeApp(config);
export var firestore = firebase.firestore();
const firestoreSettings = {
  timestampsInSnapshots: true
};
firestore.settings(firestoreSettings);

// Vuex
import Vuex from "vuex";
Vue.use(Vuex);

// Rollbar
require("./rollbarConfig.js");

// Set up Vue
void new Vue({
  router,
  store,
  el: "#app",
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./source/js/main.js